import React, { Component } from 'react';
import { Modal } from 'antd';
import UpgradeContact from './UpgradeContact';
import UpgradeInfo from './UpgradeInfo';
import UpgradeWarning from './UpgradeWarning';
import PickMonth from './PickMonth';
import Payment from './Payment';
import ConfirmPayment from './ConfirmPayment';

class UpgradeModal extends Component {
	state = {
		step: 1,
		type: 3,
		method: '',
		currency: '',
		period: '1month',
		price: 1000,
		discount: 0.1
	};

	componentDidMount() {
		const { step, user } = this.props;

		this.setState({
			step,
			type:
				user.verification_level < 3
					? 0
					: user.verification_level === 3
					? 1
					: 2
		});
	}

	componentWillReceiveProps(next) {
		const { step, user } = next;
		this.setState({
			step,
			type:
				user.verification_level < 3
					? 0
					: user.verification_level === 3
					? 1
					: 2
		});
	}

	componentWillUnmount() {
		this.setState({ step: 1 });
	}

	handleClick = (step, type) => {
		this.setState({ step, type });
	};

	renderBody() {
		const {
			step,
			type,
			method,
			// currency,
			price,
			discount,
			period
		} = this.state;
		const { handleCancel, handleOk, user } = this.props;
		switch (step) {
			case 1:
				return (
					<UpgradeWarning
						verification_level={user.verification_level}
						onOk={() => {
							this.handleClick(2, type);
						}}
						onCancel={handleCancel}
					/>
				);
			case 2:
				return (
					<UpgradeInfo
						onOk={(t) => {
							// if (t === 0) {
							// 	handleCancel();
							// 	return;
							// }
							this.handleClick(6, t);
						}}
						type={type}
						onCancel={handleCancel}
					/>
				);
			case 3:
				return (
					<PickMonth
						onOk={(period) => {
							this.setState({ step: 4, period });
						}}
					/>
				);
			case 4:
				return (
					<Payment
						onOk={(method, currency) => {
							this.setState({ step: 5, method, currency });
						}}
					/>
				);
			case 5:
				if (method === 'bank') {
					return (
						<UpgradeContact
							defaultType="Make a Payments"
							bizType={type}
							type={type}
							onOk={handleOk}
							onCancel={handleCancel}
						/>
					);
				}
				return (
					<ConfirmPayment
						type={type}
						price={price}
						user={user}
						discount={discount}
						period={period}
						onOk={() => {
							this.setState({ step: 6 });
						}}
					/>
				);
			default:
				return (
					<UpgradeContact
						defaultType="Make a Payments"
						bizType={type}
						onOk={handleOk}
						onError={handleCancel}
						onCancel={handleCancel}
					/>
				);
		}
	}

	render() {
		const { visible, handleCancel, handleOk } = this.props;
		const { step, type, method } = this.state;

		let title = '';
		switch (step) {
			case 1:
				title = null;
				break;
			case 2:
				title = 'Upgrade your Vault';
				break;
			case 3:
				title = type === 1 ? 'Business Vault' : 'Enterprise Vault';
				break;
			case 4:
				title = 'Payment Method';
				break;
			case 5:
				if (method === 'crypto') {
					title = 'Send Payment';
				} else if (method === 'bank') {
					title = 'Contact Us';
				} else {
					title = 'Confirm Payment';
				}
				break;
			default:
				break;
		}
		return (
			<Modal
				visible={visible}
				onOk={handleOk}
				onCancel={handleCancel}
				title={title}
				footer={null}
			>
				{this.renderBody()}
			</Modal>
		);
	}
}

export default UpgradeModal;
